import type { App } from '@vue/runtime-core';
import type { Pinia } from 'pinia';
import * as Sentry from '@sentry/vue';

const sentryDsn = import.meta.env.VITE_SENTRY_VUE_DSN;
const sentryRelease = import.meta.env.VITE_SENTRY_RELEASE;
const appEnv = import.meta.env.VITE_APP_ENV;
const sentryTunnelUrl = import.meta.env.VITE_SENTRY_TUNNEL_URL;

export default function initSentry(VueApp: App, pinia: Pinia) {
    if (!sentryDsn) {
        return;
    }

    Sentry.init({
        app: VueApp,
        dsn: sentryDsn,
        tunnel: sentryTunnelUrl,
        environment: appEnv,
        release: `osa-frontend@${sentryRelease}`,

        // This sets the sample rate to be 10%. You may want this to be 100% while in development and sample at a lower rate in production
        replaysSessionSampleRate: 0.1, // TODO: i guess it can be 0?

        // If the entire session is not sampled, use the below sample rate to sample sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,

        enableLogs: true,

        integrations: [
            Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
            Sentry.thirdPartyErrorFilterIntegration({
                filterKeys: ['osa-frontend'],
                behaviour: 'apply-tag-if-exclusively-contains-third-party-frames',
            }),
        ],
    });

    pinia.use(Sentry.createSentryPiniaPlugin());
}
